import axios from "@/config/axios.config";

import orderApi from "@/api/order";
// 订单确认
export function orderComfirm(data) {
	return axios({
		url: orderApi.orderConfirmUrl,
		method: "post",
		data,
	});
}
// 订单列表
export function list(data, noLoading = false) {
	return axios({
		method: "post",
		url: orderApi.listUrl,
		data,
		noLoading,
	});
}

// 订单详情
export function detail(data) {
	return axios({
		method: "post",
		url: orderApi.detailUrl,
		data,
	});
}

// 订单状态
export function status(data) {
	return axios({
		method: "post",
		url: orderApi.statusUrl,
		data,
	});
}

// 优惠券列表
export function couponList(data) {
	return axios({
		method: "post",
		url: orderApi.couponListUrl,
		data,
	});
}

// 订单确认自提时间列表
export function takeTimeList(data) {
	return axios({
		method: "post",
		url: orderApi.takeTimeListUrl,
		data,
	});
}

// 订单确认优惠码使用
export function discountCode(data) {
	return axios({
		method: "post",
		url: orderApi.discountCodeUrl,
		data,
	});
}

// 订单支付方式
export function payType(data) {
	return axios({
		method: "post",
		url: orderApi.payTypeUrl,
		data,
	});
}

// 提交订单
export function orderSubmit(data) {
	return axios({
		method: "post",
		url: orderApi.orderSubmitUrl,
		data,
	});
}

// 扫码下单成功后，需要的页面信息
export function orderOther(data) {
	return axios({
		method: "post",
		url: orderApi.orderOtherUrl,
		data,
	});
}

// 评论信息
export function commentInfo(data) {
	return axios({
		method: "post",
		url: orderApi.commentInfoUrl,
		data,
	});
}

// 评论详情
export function commentDetail(data) {
	return axios({
		method: "post",
		url: orderApi.commentDetailUrl,
		data,
	});
}

// 评论上传图片
export function uploadImg(data) {
	return axios({
		method: "post",
		url: orderApi.uploadImgUrl,
		data,
	});
}

// 提交评论
export function comment(data) {
	return axios({
		method: "post",
		url: orderApi.commentUrl,
		data,
	});
}

// 订单待支付
export function needPay(data) {
	return axios({
		method: "post",
		url: orderApi.needPayUrl,
		data,
	});
}

// 账户余额列表
export function accountList(data) {
	return axios({
		method: "post",
		url: orderApi.accountListUrl,
		data,
	});
}

// 支付提交
export function paySubmit(data) {
	return axios({
		method: "post",
		url: orderApi.paySubmitUrl,
		data,
	});
}

// 获取门店最近地址
export function getRecentAddress(data) {
	return axios({
		method: "post",
		url: orderApi.getRecentAddressUrl,
		data,
		noToast: true,
	});
}
